export default __webpack_public_path__ + "static/media/guideToInstantCardhelp@2x.6c4944b5.png";